import styled, { css } from 'styled-components';

/**
 * Variant Definitions
 */
const StyledListBidInputVariants = {
  error: css`
    border: 2px solid ${({ theme }) => theme.COLORS.ERROR};
  `
};

export const StyledListBidInput = styled.input`
  width: 122px;
  height: 36px;
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_20};
  font-size: 16px;
  border-radius: 3px;
  margin-right: 6px;
  padding: 12px;
  -moz-appearance: textfield;

  ${({ variant }) => StyledListBidInputVariants[variant]}

  &:focus {
    outline: none;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export default {};
